module.exports = function() {
  return new Worker(__webpack_public_path__ + "92950f48bb68b1c9bab4.worker.js");
};